import { useContext, useEffect, useState } from 'react';
import { LangContext } from '../../context/LangContext';
import { useToEmbed } from '../../hooks/useToEmbed';
import { useInsertBoldTag } from '../../hooks/useInsertBoldTag';
import SelectLang from '../../components/SelectLang';
import Slider from '../../components/Slider';
import Gallery from '../../components/Gallery';
import Video from '../../components/Video';

import "./style.css";

function Planning() {
    const toEmbed = useToEmbed();
    const insertBoldTag = useInsertBoldTag();
    const { language } = useContext(LangContext);
    const [formData, setFormData] = useState(null);
    const [inSubmit, setInSubmit] = useState(false);

    useEffect(() => {
        const fetchPlanningData = async () => {
            const req = await fetch(`${process.env.REACT_APP_API_URL}/planning/get`);
            const res = await req.json();

            if (req.status !== 200) alert(res.message);

            setFormData({
                descrip_fr: res.descrip_fr || '',
                descrip_en: res.descrip_en || '',
                images: res.images || [],
                gallery: res.gallery || [],
                video: res.video.length === 0 ? [''] : res.video
            });
        }
        fetchPlanningData();
    }, []);

    const setValue = (e, field) => {
        setFormData({
            ...formData,
            [field]: e.target.value
        })
    }

    const updatePlanning = async (e) => {
        e.preventDefault();

        if (inSubmit) return alert("Chargement en cours, veuillez patienter");
        else setInSubmit(true);

        const body = new FormData();

        const video = formData.video.filter(v => v !== '').map(v => toEmbed(v));
        body.append('video', JSON.stringify(video));

        body.append('descrip_fr', formData.descrip_fr);
        body.append('descrip_en', formData.descrip_en);

        // Gestion des images principales
        if (formData.images && Array.isArray(formData.images)) {
            // Envoyer d'abord l'ordre des images
            body.append('images_order', JSON.stringify(formData.images.map(img => ({
                type: img.file ? 'new' : 'existing',
                url: img.url || null,
                _url: img._url || null
            }))));

            // Ensuite envoyer les images
            formData.images.forEach((img, index) => {
                if (img.url && !img.file) {
                    // Image existante
                    body.append(`existing_images[${index}][url]`, img.url);
                    body.append(`existing_images[${index}][_url]`, img._url);
                }
                else if (img.file) {
                    // Nouvelle image
                    body.append('images', img.file);
                }
            });
        }

        // Gestion des images de la gallerie
        if (formData.gallery && Array.isArray(formData.gallery)) {
            // Envoyer d'abord l'ordre des images de la gallerie
            body.append('gallery_order', JSON.stringify(formData.gallery.map(img => ({
                type: img.file ? 'new' : 'existing',
                url: img.url || null,
                _url: img._url || null
            }))));

            // Ensuite envoyer les images
            formData.gallery.forEach((img, index) => {
                if (img.url && !img.file) {
                    // Image existante
                    body.append(`existing_gallery[${index}][url]`, img.url);
                    body.append(`existing_gallery[${index}][_url]`, img._url);
                }
                else if (img.file) {
                    // Nouvelle image
                    body.append('gallery', img.file);
                }
            });
        }

        const req = await fetch(`${process.env.REACT_APP_API_URL}/planning/edit`, {
            method: 'PUT',
            headers: { 'Authorization': `Bearer ${localStorage.getItem('token_vanrah')}` },
            body: body
        });
        const res = await req.json();
        setInSubmit(false);

        if (req.status !== 200) {
            alert(res.message);
            return
        }
        alert("Le planning a bien été mis à jour");
        setFormData(res);
    }

    return formData && (
        <form
            className='page page_planning'
            onSubmit={(e) => updatePlanning(e)}
        >
            <SelectLang />

            <section className="sect_slider_descrip">
                <Slider images={formData.images} setImages={setFormData} />

                <div className="description">
                    <p className='title_page'>
                        - <span>Planning</span> -
                    </p>

                    <div className="textarea">
                        <div className="toolbar">
                            <button
                                type="button"
                                onClick={() => insertBoldTag('.page_planning', formData, setFormData, language)}
                            >Gras</button>
                        </div>

                        <textarea
                            className="value"
                            value={formData[`descrip_${language}`]}
                            onChange={(e) => setValue(e, `descrip_${language}`)}
                            placeholder={`Description de la page en ${language === "fr" ? '"Français"' : '"Anglais"'}`}
                        ></textarea>
                    </div>
                </div>
            </section>

            <section className="sect_video">
                {/* <p className="subtitle_page">
                    - <span>Trailer</span> -
                </p> */}

                {formData.video.map((v, idx) => <Video key={idx} data={formData} counter={idx} setData={setFormData} />)}
            </section>

            <section className="sect_gallery">
                {/* <p className="subtitle_page">
                    - <span>{translations.gallery}</span> -
                </p> */}

                <Gallery gallery={formData.gallery} setGallery={setFormData} />
            </section>

            <div className="panel_form">
                <button
                    type="submit"
                    className="btn_submit"
                >modifier</button>
            </div>
        </form>
    );
}

export default Planning;